export const init = () => {
  const container = document.querySelector('.s-menu-page__content--type-1.js-content-switch-images');
  
  if (container) {
    const links = container.querySelectorAll('.js-content-image-link');
    const image = container.querySelector('.js-content-image');

    if (links.length && image) {
      image.dataset.defaultSrc = image.getAttribute('src');
      links.forEach((item) => {
        const imgSrc = item.dataset.img;
        const defaultSrc = image.dataset.defaultSrc;
        
        item.addEventListener('mouseenter', () => {
          image.src = imgSrc;
        });

        item.addEventListener('mouseleave', () => {
          image.src = defaultSrc;
        });
      });
    }
  }

  if (window.innerWidth <= 1055) {
    const activeItem = document.querySelector('.sidebar-navigation a.active');
    const content = document.querySelector('.s-menu-page__content');
    
    if (activeItem && content) {
      activeItem.parentElement.appendChild(content);
    }
  }
};